export const appRoutePaths = {
  PAGES: 'pages',
  HOME: 'home',
  PORTFOLIOS: 'portfolios',
  NEWS: 'news',
  E_DOCUMENTS: 'e-documents'
};
